module.exports = __webpack_public_path__ + "img/ex-pricing.f01fb54d.jpg";